var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Modulos")]),_c('arq-crud',{attrs:{"fields":_vm.data,"items":_vm.items}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }